/**
 * Checkout gate for post-login routing.
 *
 * Default: payment is bypassed in every environment (development and production builds).
 * Set REACT_APP_BYPASS_PAYMENT=false to require checkout after login/signup.
 * Set REACT_APP_BYPASS_PAYMENT=true to keep bypass explicit (same as default).
 */
export function isPaymentWallBypassed() {
  const flag = process.env.REACT_APP_BYPASS_PAYMENT;
  if (flag === 'false') return false;
  return true;
}

export function hasCompletedPaymentOrBypass() {
  return (
    isPaymentWallBypassed() ||
    localStorage.getItem('hasCompletedPayment') === 'true'
  );
}
